import { Routes } from '@angular/router';
import { AppLayoutComponent } from './core/layout/app-layout/app-layout';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./features/auth/pages/login/login').then((m) => m.LoginPage),
  },
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/pages/dashboard/dashboard').then(
            (m) => m.DashboardPage,
          ),
      },
      {
        path: 'my-tasks',
        data: { mineOnly: true },
        loadComponent: () =>
          import('./features/tasks/pages/task-list/task-list').then(
            (m) => m.TaskListPage,
          ),
      },
      {
        path: 'projects',
        loadComponent: () =>
          import('./features/projects/pages/project-list/project-list').then(
            (m) => m.ProjectListPage,
          ),
      },
      {
        path: 'projects/:id',
        loadComponent: () =>
          import('./features/projects/pages/project-detail/project-detail').then(
            (m) => m.ProjectDetailPage,
          ),
      },
      {
        path: 'projects/:id/gantt',
        loadComponent: () =>
          import('./features/projects/pages/project-gantt/project-gantt').then(
            (m) => m.ProjectGanttPage,
          ),
      },
      {
        path: 'tasks',
        data: { mineOnly: false },
        loadComponent: () =>
          import('./features/tasks/pages/task-list/task-list').then(
            (m) => m.TaskListPage,
          ),
      },
      {
        path: 'users',
        loadComponent: () =>
          import('./features/users/pages/user-list/user-list').then(
            (m) => m.UserListPage,
          ),
      },
      {
        path: 'calendar',
        loadComponent: () =>
          import('./features/calendar/pages/calendar/calendar').then(
            (m) => m.CalendarPage,
          ),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./features/settings/pages/settings/settings').then(
            (m) => m.SettingsPage,
          ),
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./features/profile/pages/profile/profile').then(
            (m) => m.ProfilePage,
          ),
      },
    ],
  },
  { path: '**', redirectTo: 'dashboard' },
];
